var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Dialog",
        _vm._g(
          _vm._b(
            {
              attrs: {
                visible: _vm.show,
                title: _vm.title || _vm.locale.sharePage,
                hasDecor: false,
              },
            },
            "Dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("h3", { staticClass: "ff--trajanpro-bold" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.content || _vm.locale.chooseShareMethod) +
                "\n    "
            ),
          ]),
          _c(
            "ul",
            {
              staticClass: "ff--trajanpro-bold",
              on: {
                click: function ($event) {
                  return _vm.share()
                },
              },
            },
            [
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "gtag",
                      rawName: "v-gtag:share",
                      value: "facebook",
                      expression: "'facebook'",
                      arg: "share",
                    },
                  ],
                  staticClass: "share-method",
                  attrs: { "data-method": "facebook", "data-type": "button" },
                  on: {
                    click: function ($event) {
                      return _vm.share("facebook")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "share-method__img" }),
                  _c("span", [_vm._v("Facebook")]),
                ]
              ),
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "gtag",
                      rawName: "v-gtag:share",
                      value: "message",
                      expression: "'message'",
                      arg: "share",
                    },
                  ],
                  staticClass: "share-method",
                  attrs: { "data-method": "message", "data-type": "button" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.share("message")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "share-method__img" }),
                  _c("span", [_vm._v("Message")]),
                ]
              ),
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "gtag",
                      rawName: "v-gtag:share",
                      value: "twitter",
                      expression: "'twitter'",
                      arg: "share",
                    },
                  ],
                  staticClass: "share-method",
                  attrs: { "data-method": "twitter", "data-type": "button" },
                  on: {
                    click: function ($event) {
                      return _vm.share("twitter")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "share-method__img" }),
                  _c("span", [_vm._v("Twitter")]),
                ]
              ),
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "gtag",
                      rawName: "v-gtag:share",
                      value: "mail",
                      expression: "'mail'",
                      arg: "share",
                    },
                  ],
                  staticClass: "share-method",
                  attrs: { "data-method": "mail", "data-type": "button" },
                  on: {
                    click: function ($event) {
                      return _vm.share("mail")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "share-method__img" }),
                  _c("span", [_vm._v("Mail")]),
                ]
              ),
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "gtag",
                      rawName: "v-gtag:copyLink",
                      arg: "copyLink",
                    },
                  ],
                  ref: "copyLink",
                  staticClass: "share-method",
                  attrs: { "data-method": "copy", "data-type": "button" },
                  on: {
                    click: function ($event) {
                      return _vm.share("copy")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "share-method__img" }),
                  _c("span", [_vm._v("Copy Link")]),
                ]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }